/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { toast } from 'react-toastify';
import moment from 'moment';
import _, { filter } from 'lodash';
import { getRepFilter, getFilterTeams } from '../../../api/medRepApi';
import useHospitalCoverateContext from '../context/useHospitalCoverateContext';

function Filter() {
  const { defaultFilter, filterForm, setFilterForm, handleGenerateReport } = useContext(
    useHospitalCoverateContext,
  );
  const accountOptions = [
    {
      label: 'ALL',
      value: '',
    },
    {
      label: 'Enrolled Accounts',
      value: 'enrolled_accounts',
    },
    {
      label: 'Developing Accounts',
      value: 'developing_accounts',
    },
  ];

  const dateTypeptions = [
    {
      label: 'Today',
      value: 'today',
    },
    {
      label: 'Yesterday',
      value: 'yesterday',
    },
    {
      label: 'This Week',
      value: 'this_week',
    },
    {
      label: 'Last Two Weeks',
      value: 'last_two_weeks',
    },
    {
      label: 'This Month',
      value: 'this_month',
    },
    {
      label: 'Last Month',
      value: 'last_month',
    },
    {
      label: 'Custom Range',
      value: 'custom_range',
    },
  ];

  const [repsOptions, setRepsDrowndown] = useState([]);
  const loadRepsDropdown = async () => {
    try {
      const request = {
        department: filterForm.department.value,
        team: filterForm.team.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
        manager_id: filterForm.manager_id.value,
        month: [],
        year: [],
        keyword: '',
      };
      const res = await getRepFilter(request);
      const { code, data } = res.data;
      if (code === '200') {
        const dropdownValue = data
          .filter((row) => row.rep_id !== null)
          ?.map((row, index) => ({
            value: row.rep_id,
            label: row.rep_name,
          }));
        setRepsDrowndown([{ label: 'ALL', value: '' }, ...dropdownValue]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };
  const handleChangeDate = (name, value) => {
    setFilterForm({ ...filterForm, [name]: moment(value).format('YYYY-MM-DD') });
  };

  const handleClear = () => {
    setFilterForm(defaultFilter);
    handleGenerateReport('reset');
  };

  useEffect(() => {
    loadRepsDropdown();
  }, [filterForm]);
  return (
    <Box sx={{ pl: 3, pr: 3, mt: 2 }}>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Specialists' />}
            size='small'
            value={filterForm.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='account_type'
            disableClearable
            fullWidth
            options={accountOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Account Type' />}
            size='small'
            value={filterForm.account_type}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'account_type')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='date_filter_type'
            disableClearable
            fullWidth
            options={dateTypeptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Date Type' />}
            size='small'
            value={filterForm.date_filter_type}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'date_filter_type')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        {filterForm?.date_filter_type?.value === 'custom_range' ? (
          <>
            <Grid md={1}>
              <DesktopDatePicker
                label='Date From'
                inputFormat='MM/DD/YYYY'
                value={filterForm.date_from}
                onChange={(e) => handleChangeDate('date_from', e)}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField size='small' {...params} />}
                sx={{ marginTop: '10px', backgroundColor: '#fff' }}
                disableFuture
              />
            </Grid>
            <Grid md={1}>
              <DesktopDatePicker
                label='Date To'
                inputFormat='MM/DD/YYYY'
                value={filterForm.date_to}
                fullWidth
                onChange={(e) => handleChangeDate('date_to', e)}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField size='small' {...params} />}
              />
            </Grid>
          </>
        ) : (
          ''
        )}
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClear()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default Filter;
